export default __webpack_public_path__ + "static/media/g2021-9.202ee42a.jpeg";